import fox from "../Screenshot 2024-10-02 125330.jpg"
import turtle from "../Screenshot 2024-10-02 124242.png"
// import Stack from 'react-bootstrap/Stack';


export default function ImageTextComponent() {



    // return (
    //     <Stack direction="horizontal" className="introduction">
    //         <img src={turtle} alt="Left" className="turtle_image" />
    //         <div className="text-content">
    //             <h1>Centered Text</h1>
    //             <p>This is the text that will appear in between the two images.</p>
    //         </div>
    //         <img src={fox} alt="Right" className="fox_image" />  
    //     </Stack>
    // );

    return (
        <div className="grid-container">
          <img src={turtle} alt="Left" className="side-image" />
          <div className="center-text">
            <h1>Crazy Turtle Taxi</h1>
            <p>"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."</p>
          </div>
          <img src={fox} alt="Right" className="side-image" />
        </div>
      );
}